import React, { HTMLAttributes } from 'react';
import { InformationIcon } from '../../assets/icons/InformationIcon';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Information.scss';
const rootClassName = 'component-information-icon';

export interface InformationProps extends HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  icon: React.ReactNode | JSX.Element;
}
export default function Information(props: InformationProps) {
  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([rootClassName, props.className || ''])
    };
    delete p.icon;
    delete p['tooltip-text'];
    delete p['tooltip-position'];
    return p;
  };
  return (
    <div {...getProps()}>
      <div
        className={`${rootClassName}-icon`}
        tooltip-text={props['tooltip-text']}
        tooltip-position={props['tooltip-position']}
      >
        {props.icon}
      </div>
    </div>
  );
}

Information.defaultProps = {
  icon: <InformationIcon />
};
